import $ from 'jquery';

$('.load-more-ajax').on('click', function(e) {
  e.preventDefault();
  var button = e.currentTarget;
  var page = (typeof $(this).data('page') !== 'undefined')? $(this).data('page') : undefined;
  var type = (typeof $(this).data('post-type') !== 'undefined')? $(this).data('post-type') : undefined;
  var tax = (typeof $(this).data('taxonomy') !== 'undefined')? $(this).data('taxonomy') : undefined;
  var tax_term = (typeof $(this).data('term') !== 'undefined')? $(this).data('term') : undefined;
  var action = ($(this).data('action') == 'load-recent')? 'load_recent' : 'load_sticky';

  $.ajax({
    url: '/wp-admin/admin-ajax.php',
    method: 'post',
    dataType: 'json',
    data: {
      action: action,
      page: page,
      post_type: type,
      taxonomy: tax,
      term: tax_term,
    },
    success: function(response) {
      console.log(response);
      $(button).siblings('.ajax-posts').append(response.output);
      $(button).data('page', page + 1);
      if(page >= response.max){
        $(button).hide();
      }
    }, 
    error: function(response){
      console.log(response);
    }
  });
});